import { render, staticRenderFns } from "./manage-param-sagefemme.html?vue&type=template&id=a5896b8a&scoped=true&external"
import script from "./manage-param-sagefemme.js?vue&type=script&lang=js&external"
export * from "./manage-param-sagefemme.js?vue&type=script&lang=js&external"
import style0 from "./manage-param-sagefemme.scss?vue&type=style&index=0&id=a5896b8a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5896b8a",
  null
  
)

export default component.exports